import { CART_SUCESS, GROSS_AMOUNT, FINAL_ORDER_PRICE,COMPANY_NAME, SHOP_NAME } from './action-types';
const initialState = {
    cartItems: [],
    grossAmount: '',
    finalOrderPrice: '',
    companyName : "",
    shopName : "",
};

export const cart = (state = initialState, { type, payload = null }: any): any => {
    switch (type) {
        case CART_SUCESS:
            return {
                ...state,
                cartItems: payload,
            };
        case GROSS_AMOUNT:
            return {
                ...state,
                grossAmount: payload,
            };
        case FINAL_ORDER_PRICE:
            return {
                ...state,
                finalOrderPrice: payload,
            };
            case COMPANY_NAME:
            return {
                ...state,
                companyName: payload,
            };
            case SHOP_NAME:
            return {
                ...state,
                shopName: payload,
            };
        default:
            return state;
    }
};
